/**
 * Cita de un iKu (GEN-EKB-023): el enlace profundo del Pórtico al detalle de un iKu de Saber.
 * Jimmy cita cada iKu que usa como [Título](#/saber/iku/<id>); el kernel entrega el enlace ya hecho
 * (`RUTA_IKU` de las herramientas de lectura de Saber) y el Pórtico solo reconoce esta forma.
 * Pulsar el enlace cambia el hash y AppShell abre Saber con ese iKu en el centro; sirve igual desde
 * la columna derecha de Saber que desde Chats.
 */
export const PREFIJO_CITA_IKU = '#/saber/iku/'
export const PREFIJO_CITA_KB = '#/saber/kb/' // GEN-EKB-024: el enlace con el que Jimmy confirma un KB recién creado
const ID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
const RE_HASH = new RegExp(`^#/saber/iku/(${ID})$`)
const RE_HASH_KB = new RegExp(`^#/saber/kb/(${ID})$`)

/** GEN-PX-031: página propia de un área de Saber (`#/saber/area/<id>`); a diferencia de las citas, el hash se conserva (atrás y compartir). */
export const PREFIJO_AREA = '#/saber/area/'
export function areaDeHash(hash) {
  const m = /^#\/saber\/area\/([\w-]+)$/.exec(hash ?? '')
  return m ? m[1] : null
}

/** Id del KB de un hash de enlace a un KB (`#/saber/kb/<id>`), o null. */
export function kbDeHash(hash) {
  const m = RE_HASH_KB.exec(hash ?? '')
  return m ? m[1].toLowerCase() : null
}

/** Id del iKu de un hash de cita, o null si el hash no es de una cita. */
export function ikuDeHash(hash) {
  const m = RE_HASH.exec(hash ?? '')
  return m ? m[1].toLowerCase() : null
}

/** Reemplaza las citas `[Título](#/saber/iku/id)` (y los enlaces a un KB `[Nombre](#/saber/kb/id)`) de un texto YA ESCAPADO por enlaces; cualquier otro enlace queda como texto. */
export function enlazarCitas(textoEscapado) {
  return textoEscapado.replace(
    new RegExp(`\\[([^\\]\\n]+)\\]\\((${PREFIJO_CITA_IKU}${ID}|${PREFIJO_CITA_KB}${ID})\\)`, 'g'),
    (_, titulo, ruta) => `<a class="cita-iku" href="${ruta}">${titulo}</a>`,
  )
}
